import './subscription.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSentence } from '../../translations';

const Cancel = () => {
  const navigate = useNavigate();
  const locacion = useLocation();

  const handleClick = async (e) => {
    e.preventDefault();

    await fetch('api/cancel-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        subscriptionId: locacion.state.subscription
      }),
    })

    navigate('/account', { replace: true });
  };

  return (
    <div>
      <h1>{getSentence(8)}</h1>
      <button onClick={handleClick}>{getSentence(8)}</button>
    </div>
  )
}


export default Cancel;